import React, { Component } from "react";
import { Link, withRouter  } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { registerUser } from "../../actions/authActions";
import classnames from "classnames";
import authLogo from "../../images/magnituteLogo.png"


class Register extends Component {

    constructor() {
        super();
        this.state = {
            name: "",
            email: "",
            password: "",
            password2: "",
            errors: {},
            oldshowPassword:false,
            confirmshowPassword:false
        };
    }

    componentDidMount() {
        if (this.props.auth.isAuthenticated) {
            this.props.history.push("/dashboard");
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
    }

    onChange = e => {
        this.setState({ [e.target.id]: e.target.value });
    };

    onSubmit = e => {
        e.preventDefault();
        const newUser = {
            name: this.state.name,
            email: this.state.email,
            password: this.state.password,
            password2: this.state.password2
        };
        this.props.registerUser(newUser, this.props.history);
    };

    render() {
        const { errors,oldshowPassword, confirmshowPassword } = this.state;
        return (
          <div className="container">
              <div className="flex_center">
                <div className="row my-5">
                    <div className="col-md-12 mx-auto">
                    <div className="card">
                        <div className="card-body p-4">
                        <center className="pt-3">
                          {/* <h2 className="form_header">Bell Exchange</h2> */}
                          <img src={authLogo} className="img-fluid img_form" alt="Logo" />
                           </center>
                            <h2 className="text-center text-primary mt-3">Register</h2>
                        <form noValidate onSubmit={this.onSubmit} className="white formcur_default">
                        <label htmlFor="name">Name</label>
                                <input
                                    onChange={this.onChange}
                                    value={this.state.name}
                                    id="name"
                                    type="text"
                                    error={errors.name}
                                    className={classnames("form-control", {
                                        invalid: errors.name
                                    })}
                                />
                                <span className="text-danger">{errors.name}</span>
                                <br/>
                                <label htmlFor="email">Email</label>
                                <input
                                    onChange={this.onChange}
                                    value={this.state.email}
                                    error={errors.email}
                                    id="email"
                                    type="email"
                                    className={classnames("form-control", {
                                        invalid: errors.email
                                    })}
                                />
                                <span className="text-danger">{errors.email}</span>
                                <br/>
                                <label htmlFor="password">Password</label>
                                <div class="input-group input_grp_width no_warp_flex_input">
                                <input
                                    onChange={this.onChange}
                                    value={this.state.password}
                                    error={errors.password}
                                    id="password"
                                    type="password"
                                    className={classnames("form-control", {
                                        invalid: errors.password
                                    })}
                                />
                                <div className="input-group-append">
                                                      <Link
                            className="input-group-text no_underline" id="basic-addon2"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({ oldshowPassword: !oldshowPassword });
                            }}
                            >
                               <i className={oldshowPassword && oldshowPassword ?"fa fa-eye cur_pointer_icon":"fa fa-eye-slash cur_pointer_icon"}></i>
                            </Link>
                          </div>
                                </div>
                                <span className="text-danger">{errors.password}</span>
                                <br/>
                                <label htmlFor="password2">Confirm Password</label>
                                <div class="input-group input_grp_width no_warp_flex_input">
                              <input
                                    onChange={this.onChange}
                                    value={this.state.password2}
                                    id="password2"
                                    type="password"
                                    className={classnames("form-control", {
                                        invalid: errors.password2
                                    })}
                                />
                                <div className="input-group-append">
                                                      <Link
                            className="input-group-text no_underline" id="basic-addon2"
                              onClick={(e) => {
                                e.preventDefault();
                                this.setState({ confirmshowPassword: !confirmshowPassword });
                            }}
                            >
                               <i className={confirmshowPassword && confirmshowPassword ?"fa fa-eye cur_pointer_icon":"fa fa-eye-slash cur_pointer_icon"}></i>
                            </Link>
                          </div>
                          </div>
                                <span className="text-danger">{errors.password2}</span>

                                <p className="text-center pb-0 mt-2">
                                    <button
                                        type="submit"
                                        className="btn btn-large btn-primary mt-2 px-5">
                                        Sign up
                                    </button>
                                </p>

                        </form>
                    
                         
                            <p className="grey-text text-darken-1 font_15 mt-4">
                                Already have an account? <Link to="/login" className="link_blue_new">Log in</Link>
                            </p>
                        </div>
                     
                        </div>
                        </div>
                        </div>
                    </div>
                    </div>
                   

        );
    }
}

Register.propTypes = {
    registerUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { registerUser }
)(withRouter(Register));
